import React from 'react';

import { FormikHelpers } from 'formik';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { addStop, errorAlert, getStation, successAlert } from 'actions';
import { updateStopCodeApi } from 'app/operations/stations/station-api';
import {
  StopFormState,
  extractNumericCode,
} from 'app/operations/stations/stop-helpers';
import { useTypedSelector } from 'helpers';
import { Station } from 'types';

import { StopForm } from './stop-form';

const initialState: StopFormState = {
  ar_name: '',
  en_name: '',
  lon: '',
  lat: '',
  stop_code: '',
};

interface AddStopProps {
  setOpen: (newState: boolean) => void;
}

const AddStop: React.FC<AddStopProps> = ({ setOpen }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const match = useRouteMatch<{ id: string }>();

  const stationId = match.params.id;

  const stationData = useTypedSelector(
    state => state.stations.collection[stationId] as Station | undefined
  );

  const handleSubmit = async (
    values: StopFormState,
    { setSubmitting }: FormikHelpers<StopFormState>
  ) => {
    setSubmitting(true);
    try {
      const numericCode = extractNumericCode(values.stop_code);

      const { action }: any = await Promise.resolve(
        dispatch(
          addStop({
            en_name: values.en_name,
            ar_name: values.ar_name,
            lon: values.lon,
            lat: values.lat,
            code: numericCode,
            station_id: stationId,
            organisation_id: stationData?.organisation_id,
          })
        )
      );

      const newStopId = action?.payload?.data?.response?.stop?.id;

      if (newStopId) {
        try {
          await updateStopCodeApi(newStopId, values.stop_code);
        } catch (err: any) {
          const message =
            err?.response?.data?.message ||
            intl.formatMessage({ id: 'stopCodeUpdateFailed' });

          dispatch(errorAlert(message));
        }
      }

      setOpen(false);
      dispatch(getStation(stationId));
      dispatch(successAlert(intl.formatMessage({ id: 'successAddStop' })));
    } finally {
      setSubmitting(false);
    }
  };

  return <StopForm {...{ initialState, handleSubmit, setOpen }} />;
};

export { AddStop };
